// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__8vsfz","content":"LayoutSettings_content__23v7N"};